<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item
           
            @click="openEditView(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item
         
            @click="openConfirm(params.data.id, params.data,'single','lesson')"
            >Delete</vs-dropdown-item
          >
         
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import {DeleteMixin} from './mixins/DeletingMixins'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  mixins: [PermissionMiddleware, DeleteMixin],
  name: 'CellRendererAction',
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Lesson')
    }
  },
  data () {
    return {
      questionApplicationType:'General',
      listingtype: 'lesson'
    }
  },
  mounted () {
  },
  methods: {
    openEditView (editingObject) {

      this.$router.push({
        name: 'lesson edit',
        params: { lesson_id: editingObject.id
        }
      })
      
    }
  }
}
</script>